import React from 'react';
import PropTypes from 'prop-types';
import { Space, Typography } from 'antd';
import EbzButton from 'components/EbzButton';

function DashboardCommomFooter({ filterGraphData, resetDashboardForm }) {
  return (
    <Space style={{ justifyContent: 'end', display: 'flex' }}>
      <Space>
        <EbzButton
          style={{ color: 'var(--color-primary)', border: '1px solid', width: '94px' }}
          size="large"
          onClick={() => {
            resetDashboardForm();
          }}
          type="primary"
        >
          <Typography.Text style={{ fontSize: '14px', color: 'var(--color-primary)' }}>
            Reset
          </Typography.Text>
        </EbzButton>
      </Space>
      <Space>
        <EbzButton
          style={{
            color: 'var(--color-primary)',
            backgroundColor: 'var(--color-primary)',
            border: '1px solid',
            width: '94px'
          }}
          size="large"
          onClick={() => {
            filterGraphData();
          }}
        >
          <Typography.Text style={{ fontSize: '14px', color: 'white' }}>Apply</Typography.Text>
        </EbzButton>
      </Space>
    </Space>
  );
}

DashboardCommomFooter.propTypes = {
  filterGraphData: PropTypes.func.isRequired,
  resetDashboardForm: PropTypes.func.isRequired
};
export default DashboardCommomFooter;
